export default function FormSubtitle({className = "", ...props}){

    return(
        <h5 className={`text-center pt-2 pb-1 ${className}`}>{props.children}</h5>
    );
}